<template>
  <div
      class="subscriber-count"
      :class="$vuetify.theme.dark === true ? ` dark`:` light`"
  >
    {{ count }}
  </div>
</template>

<script>
export default {
  name: 'SubscriberCount',
  props: {
    count: {
      type: Number,
      default: 0,
    }
  }
}
</script>

<style lang="scss" scoped>
.subscriber-count {
  position: absolute;
  left: 30px;
  bottom: 8px;
  border: 1px solid;
  width: 1.2em;
  height: 1.2em;
  padding: 0;
  border-radius: 50%;
  text-align: center;
  font-size: 0.8em;

  &.dark {
    background-color: #000000;
    border-color: #ffffff;
  }

  &.light {
    background-color: #FFFFFF;
    border-color: rgb(116, 0, 255);
  }
}
</style>